import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  breakdown: {},
  applicationInitalData: {},
  documents: [],
  property: {},

  buyers: [],
  sellers: [],
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: 'WAIVER_MUSATAHA',
  propertyDocuments: null,

  companyLookup: [],
  emrtsLookup: [],
};

export default function musatahaReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.INITIATE_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        applicationInitalData: action.payload.applicationInitalData,
        property: action.payload.property,
        companyLookup: action.payload.companyLookup,
        emrtsLookup: action.payload.emrtsLookup,
        error: null,
      };
    case types.FETCH_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_MUSATAHA_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_MUSATAHA_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_MUSATAHA_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_MUSATAHA_CONTRACT:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_MUSATAHA_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        application: action.payload.application,
      };
    case types.FETCH_MUSATAHA_CONTRACT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.MUSATAHA_FIELD_CHANGE:
      return {
        ...state,
        application: {
          ...state.application,
          contractDetails: {
            ...state.application?.contractDetails,
            ...action.payload,
          },
        },
      };
    case types.FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: action.payload,
      };
    case types.FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_MUSATAHA_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_MUSATAHA_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        buyers: get(action.payload, 'buyers', []),
      };
    }
    case types.ADD_MUSATAHA_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.SAVE_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.SAVE_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        activeStep: action?.payload?.activeStep ? action?.payload?.activeStep : state.activeStep + 1,
      };
    case types.SAVE_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DELETE_MUSATAHA_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_MUSATAHA_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        buyers: get(action.payload, 'buyers', []),
        documents: get(action.payload, 'newDocuments.result', []),
      };
    }
    case types.DELETE_MUSATAHA_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.MUSATAHA_CHANGE_APPLICATION_STEP:
      return {
        ...state,
        activeStep: action?.payload,
      };
    case types.MUSATAHA_FORM_VALIDATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_MUSATAHA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_MUSATAHA_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_MUSATAHA_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_APPLICATION_WAIVE_MUSATAHA:
      return {
        ...state,
        loading: true,
        application: null,
        error: null,
      };
    case types.FETCH_APPLICATION_WAIVE_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        buyers: get(action.payload, 'buyers', []),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        breakdown: get(action.payload, 'breakdown', {}),
        sellers: get(action.payload, 'sellers', {}),
        error: null,
      };
    case types.FETCH_APPLICATION_WAIVE_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_MUSATAHA_DOCUMENTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_MUSATAHA_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        documents: action.payload,
      };
    }
    case types.GET_MUSATAHA_DOCUMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_FORM:
      return {
        ...state,
        ...action.payload.data,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case types.DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_MUSATAHA_WAIVER:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_MUSATAHA_WAIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        breakdown: get(action.payload, 'breakdown', {}),
        error: null,
      };

    case types.SAVE_APPLICATION_MUSATAHA_WAIVER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.MUSATAHA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.MUSATAHA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CLEAR_MUSATAHA_APPLICATION_ERROR:
      return {
        ...defaultState,
      };
    case types.MUSATAHA_PROPERTY_DOCUMENTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MUSATAHA_PROPERTY_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        propertyDocuments: action.payload,
        error: null,
      };
    }
    case types.MUSATAHA_PROPERTY_DOCUMENTS_ERROR:
      return {
        ...state,
        loading: false,
        propertyDocuments: null,
        error: action.payload,
      };
    case types.CLEAR_MUSATAHA_CONTRACT_PERIOD:
      return {
        ...state,
        breakdown: {},
        application: {
          ...state.application,
          contractDetails: {
            ...state.application.contractDetails,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
}
